import { render, staticRenderFns } from "./VendorTagCategory.vue?vue&type=template&id=13a45c11"
import script from "./VendorTagCategory.vue?vue&type=script&lang=js"
export * from "./VendorTagCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports